<lgv-auth-wrapper text="auth_registrationlink_headline">
  @if (!tokenNotFound) {
    <div class="hello" style="text-align: center; padding-bottom: 10px">
      {{ 'auth_registrationlink_message' | translate }} {{ firstname }}!
    </div>
  }
  @if (!tokenNotFound) {
    <form [formGroup]="formGroup" class="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline">
        <mat-label translate>auth_registrationlink_email_label</mat-label>
        <input matInput formControlName="email" type="email" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label translate>auth_registrationlink_password_label</mat-label>
        <input matInput formControlName="password" type="password" minlength="8" />
        @if (this.getField('password').hasError('minlength')) {
          <mat-error translate> auth_registrationlink_password_error </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label translate>auth_registrationlink_repeatpassword_label</mat-label>
        <input matInput formControlName="repeatPassword" type="password" />
        @if (this.getField('repeatPassword').hasError('mismatch')) {
          <mat-error translate> auth_registrationlink_repeatpassword_error </mat-error>
        }
      </mat-form-field>
      <lgv-auth-button [isLoading]="isLoading"></lgv-auth-button>
    </form>
  }
  @if (!tokenNotFound) {
    <button mat-button color="primary" routerLink="/login">
      {{ 'auth_registrationlink_button_login' | translate }}
    </button>
  }
  @if (tokenNotFound) {
    <div style="text-align: center; padding-bottom: 10px" translate>auth_registrationlink_error</div>
  }
</lgv-auth-wrapper>
